import React from 'react';
import { XCircle } from 'lucide-react';
const points = ['Cercare attività online e materiali aggiornati', 'Inventare verifiche e rubriche di valutazione', 'Preparare presentazioni per spiegare argomenti complessi', 'Organizzare dibattiti e compiti di realtà', 'Pianificare progetti interdisciplinari con i colleghi'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-main py-24 px-4 relative overflow-hidden" data-id="element-81">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none opacity-30 blur-3xl" style={{
      background: 'radial-gradient(circle, rgba(239,68,68,0.1) 0%, transparent 70%)'
    }} data-id="element-82"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-83">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-6 text-center tracking-tight" data-id="element-84">
          Quante ore perdi ogni settimana preparando Educazione Civica?
        </h2>

        <p className="text-text-sec text-lg sm:text-xl text-center mb-12 max-w-2xl mx-auto" data-id="element-85">
          Molti docenti ricevono l'incarico di Educazione Civica senza avere
          materiali pronti. Ogni settimana significa:
        </p>

        <div className="space-y-4 mb-10" data-id="element-86">
          {points.map((point, i) => <div key={i} className="flex items-center gap-5 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light hover:border-badge-red/30 transition-colors group shadow-sm" data-id="element-87">
              <div className="flex-shrink-0" data-id="element-88">
                <XCircle className="w-6 h-6 text-badge-red/70 group-hover:text-badge-red transition-colors" data-id="element-89" />
              </div>
              <p className="text-text-main text-lg font-medium leading-relaxed" data-id="element-90">
                {point}
              </p>
            </div>)}
        </div>

        <div className="bg-badge-red/5 border border-badge-red/20 rounded-2xl p-6 text-center" data-id="element-91">
          <p className="text-text-main text-xl font-bold" data-id="element-92">
            Alla fine dell'anno possono essere oltre{' '}
            <span className="text-badge-red font-black" data-id="element-93">
              150 ore di lavoro extra
            </span>
            .
          </p>
        </div>
      </div>
    </section>;
}